import { takeLatest, call, put } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import request from '../../Utils/Request';
import { storeArchiveModels } from './ModelArchive.reducer';

export const fetchArchiveModels = createAction('FETCH_ARCHIVE_MODELS');
export const modelUnarchive = createAction('UNARCHIVE_MODEL');

const modelList = {
  list: [
    {
      accuracy: '100.0',
      averageTime: '0.049',
      modelCreatedAt: 1599544955098,
      modelDescription: 'Trained for 20 epochs',
      modelId: 1,
      modelIsActive: true,
      modelModifiedAt: 1599657244833,
      modelName: 'Grid',
      modelReleasedAt: 1599657245474,
      modelType: 'Supervised',
      precision: '1.0',
      recall: '1.0',
    },
    {
      accuracy: '100.0',
      averageTime: '0.049',
      modelCreatedAt: 1599544955098,
      modelDescription: 'Trained for 20 epochs',
      modelId: 2,
      modelIsActive: true,
      modelModifiedAt: 1599657244833,
      modelName: 'Test',
      modelReleasedAt: 1599657245474,
      modelType: 'Unsupervised',
      precision: '1.0',
      recall: '1.0',
    },
    {
      accuracy: '100.0',
      averageTime: '0.049',
      modelCreatedAt: 1599544955098,
      modelDescription: 'Trained for 20 epochs',
      modelId: 3,
      modelIsActive: true,
      modelModifiedAt: 1599657244833,
      modelName: 'Test 123',
      modelReleasedAt: 1599657245474,
      modelType: 'Supervised',
      precision: '1.0',
      recall: '1.0',
    },
  ],
  totalRecords: 3,
};

function* getArchiveModelList(action) {
  try {
    const response = yield call(request, '/rest/model/archiveModels', {
      action,
    });
    if (response.status === 200) {
      yield put(storeArchiveModels(modelList));
    }
  } catch (error) {
    console.log(error);
    yield put(storeArchiveModels(modelList));
    if (action.payload.callback) {
      action.payload.callback(modelList.list[0]);
    }
  }
}
function* unArchiveModel(action) {
  try {
    const response = yield call(request, '/rest/model/unarchiveModel', {
      action,
    });
  } catch (error) {
    console.log(error);
  }
}

export default function* modelArchiveSaga() {
  const watcher = [];
  watcher.push(
    yield takeLatest(fetchArchiveModels.toString(), getArchiveModelList)
  );
  watcher.push(yield takeLatest(modelUnarchive.toString(), unArchiveModel));
}
